import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const ConfirmDialog = ({
	open,
	setOpen,
	title,
	content,
	onConfirm,
	positiveButtonText,
	negativeButtonText,
}) => {
	return (
		<div>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{content}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							setOpen(false);
							onConfirm();
						}}
						color="primary">
						{positiveButtonText || "Yes"}
					</Button>
					<Button onClick={() => setOpen(false)} color="secondary" autoFocus>
						{negativeButtonText || "No"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
export default ConfirmDialog;
